// src/utils.js
import axios from 'axios';

const RAW_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const API_BASE_URL = `${RAW_API_URL}/api`;

// Obtener todas las tareas
export const fetchTasks = async () => {
  const response = await axios.get(`${API_BASE_URL}/tasks`);
  return response.data;
};

// Obtener todos los usuarios
export const fetchUsers = async () => {
  const response = await axios.get(`${API_BASE_URL}/users`);
  return response.data;
};

// Crear una nueva tarea
export const createTask = async (taskData) => {
  const response = await axios.post(`${API_BASE_URL}/tasks`, taskData);
  return response.data;
};

// Actualizar una tarea existente (usando PATCH para compatibilidad con backend)
export const updateTask = async (id, updatedData) => {
  const response = await axios.patch(`${API_BASE_URL}/tasks/${id}`, updatedData);
  return response.data;
};

// Eliminar una tarea
export const deleteTask = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/tasks/${id}`);
  return response.data;
};

// Normalizar estado para clases CSS (ej. "En Progreso" -> "en-progreso")
export const normalizeStatus = (status) => {
  if (!status || typeof status !== 'string') return '';
  const clean = status
    .normalize('NFD') // separa letras y tildes
    .replace(/[\u0300-\u036f]/g, '') // remueve tildes
    .toLowerCase()
    .replace(/\s+/g, '-'); // reemplaza espacios por guiones
  return clean;
};

